"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var BackgroundTasks = function BackgroundTasks(_ref) {
  var title = _ref.title,
    children = _ref.children,
    id = _ref.id;
  var _React$useState = _react["default"].useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_material.Accordion, {
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(!expanded);
    },
    sx: {
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      "&:hover": {
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
      },
      transition: "box-shadow 0.2s ease-in-out",
      borderRadius: "8px",
      "&:before": {
        display: "none" // Elimina la línea divisoria por defecto del Accordion
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.AccordionSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "mdi:chevron-down"
    }),
    "aria-controls": "panel2-content-".concat(id),
    id: "panel2-header-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "span",
    sx: {
      width: "100%"
    }
  }, title)), /*#__PURE__*/_react["default"].createElement(_material.AccordionDetails, null, children.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "".concat(id, "-").concat(index)
    }, item);
  })));
};
var _default = exports["default"] = BackgroundTasks;